































































import { Component, Inject, Mixins } from "vue-property-decorator";
import {
  ICProdProvider,
  ICProdProviderMethods
} from "@/models/providers/contractProduct";
import Context from "@/mixins/context";
import { IFraudEvent } from "@/models/fraud";

@Component({
  components: {
    "cprod-prov-actions": () =>
      import("@/components/app/global/contractProducts/cProdProvActions.vue"),
    "cprod-image": () =>
      import("@/components/app/global/contractProducts/cProdImage.vue"),
    "cprod-tags": () =>
      import("@/components/app/global/contractProducts/cProdTags.vue"),
    "fraud-provider": () =>
      import("@/components/app/global/fraud/fraudProvider.vue"),
    "fraud-status": () =>
      import("@/components/app/global/fraud/fraudStatus.vue")
  }
})
export default class CProductHeader extends Mixins(Context) {
  // Inject

  @Inject({ from: "contractProductProvider" })
  public readonly $cProdData!: () => ICProdProvider;

  @Inject({ from: "contractProductProviderMethods" })
  public readonly $cProdMethods!: ICProdProviderMethods;

  // Computed

  public get cProdData() {
    return this.$cProdData();
  }

  public get provConfigurationName() {
    return this.cProdData.contractProduct?.provision_configuration?.name;
  }

  // Life-cycle methods

  public created() {
    this.$bus.$on(`new-fraud-event`, this.fraudEventListener);
  }

  public beforeDestroy() {
    this.$bus.$off(`new-fraud-event`, this.fraudEventListener);
  }

  // Methods

  public fraudEventListener(event: IFraudEvent) {
    if (event.client_id === this.cProdData.contract.client_id) {
      this.$cProdMethods.loadContractData(true);
    }
  }
}
